import React from 'react';
import './About.css';
import aaa from '../../assets/aaa.jpeg'; // Senin eklediğin görsel importu

function About() {
  return (
    <section className="about-section" id="hakkinda">
      <div className="about-container">
        
        {/* Sol Taraf - Fotoğraf ve Dinamik Rozet */}
        <div className="about-image-wrapper">
          <img 
            src={aaa} 
            alt="Turan Hoca" 
            className="about-img"
          />
         
        </div>

        {/* Sağ Taraf - Yazılar ve İstatistikler */}
        <div className="about-content">
          <span className="section-subtitle">TURAN HOCA KİMDİR?</span>
          <h2>Yeni Nesil Sisteme, <span className="text-gold">Yeni Nesil Eğitimci.</span></h2>

           <p className="about-description">
            Merhaba ben Turan Hoca. İlköğretim Matematik Öğretmeniyim. Matematik Eğitimi Anabilim Dalında yüksek lisans yapmaktayım. Aktif olarak her düzeyde özel ders vermekteyim.

          </p>
          
          <p className="about-description">
            2025 yılında Tokat Gaziosmanpaşa Üniversitesi'nde lisans eğitimini tamamlayan genç ve dinamik bir eğitimci olarak, güncel sınav sisteminin (YKS, LGS) zorluklarını ve öğrencilerin psikolojisini çok iyi biliyorum. Çünkü bu yollardan yakın zamanda geçtim ve onlarla <strong>aynı dili konuşuyorum.</strong>
          </p>
          <p className="about-description">
            Eski usul, sıkıcı ve ezbere dayalı klasik anlatımları bir kenara bırakıyoruz. Amacım; yüksek enerjili, yeni nesil soru tiplerini pratik yollarla çözen ve öğrencinin motivasyonunu her zaman zirvede tutan bir yol arkadaşı olmak.
          </p>

          {/* İstatistik Kutuları - Yeni nesil vizyona uygun */}
          <div className="stats-container">
            <div className="stat-box">
              <h3>%100</h3>
              <p>Güncel Müfredat</p>
            </div>
            
            <div className="stat-box">
              <h3>Yeni</h3>
              <p>Nesil Taktikler</p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default About;